import dynamic from "next/dynamic";
// import CombosPage from "../../src/combos/CombosPage.tsx";
const CombosPage = dynamic(() => import("../../src/combos/CombosPage.tsx"), {
  ssr: false,
});

export default function Player({ path, exaltedGroups }) {
  return <CombosPage path={path} exaltedGroups={exaltedGroups} />;
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ locale, params }) {
  const exaltedsResp = await fetch(
    `https://ap.tft.tools/static/s11/exalteds.json`,
  );
  const exaltedGroups = await exaltedsResp.json();

  return {
    props: {
      exaltedGroups,
      locale,
      path: params.path,
    },
    revalidate: 3600,
  };
}
